<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import InboxesSelector from '../../create/InboxesSelector.vue';

const props = defineProps({
  bot: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
const store = useStore();

const inboxList = useMapGetter('inboxes/getInboxes');

const selectedInboxes = ref([]);
const isUpdating = ref(false);

const sortedInboxes = computed(() => {
  return [...(inboxList.value || [])].sort((a, b) => a.id - b.id);
});

const headerDesc = computed(() => {
  return t('WGPT_BOTS.EDIT.TABS.INBOXES.DESC', { botName: props.bot.name });
});

const updateSelectedInboxes = newInboxList => {
  selectedInboxes.value = [...newInboxList];
};

const setDefaults = () => {
  selectedInboxes.value = [...(props.bot.inbox_ids || [])];
};

const assignInboxes = async () => {
  isUpdating.value = true;
  try {
    await store.dispatch('wgptBots/update', {
      id: props.bot.id,
      inbox_ids: selectedInboxes.value,
    });
    store.dispatch('wgptBots/get');
    useAlert(t('WGPT_BOTS.EDIT.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(error.message);
  }
  isUpdating.value = false;
};

watch(() => props.bot, setDefaults);

onMounted(() => {
  store.dispatch('inboxes/get');
  setDefaults();
});
</script>

<template>
  <div class="mx-6 max-w-4xl">
    <div class="flex flex-col gap-1 mb-6">
      <h6 class="text-heading-3 text-n-slate-12">
        {{ $t('WGPT_BOTS.EDIT.TABS.INBOXES.TITLE') }}
      </h6>
      <span class="text-body-main text-n-slate-11">
        {{ headerDesc }}
      </span>
    </div>

    <form @submit.prevent="assignInboxes">
      <InboxesSelector
        :inbox-list="sortedInboxes"
        :selected-inboxes="selectedInboxes"
        :update-selected-inboxes="updateSelectedInboxes"
        :is-working="isUpdating"
        :submit-button-text="$t('WGPT_BOTS.EDIT.TABS.INBOXES.FORM.SUBMIT')"
      />
    </form>
  </div>
</template>
